class StickyProVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onStickyVariantChange);
  }

  onStickyVariantChange() {
    this.varOptions = this.querySelector("select");
    //console.log("connected", this.varOptions.value);

    let productForms = document.querySelector(
      `#product-sticky-form-${this.dataset.section}`
    );
    let input = productForms.querySelector('input[name="id"]');
    input.value = this.varOptions.value;
  }
}
customElements.define("sticky-variant-select", StickyProVariantSelect);

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    stickyScroll();
  });
  document.addEventListener("shopify:section:select", (event) => {
    stickyScroll();
  });
  document.addEventListener("shopify:section:deselect", (event) => {
    stickyScroll();
  });
}

const stickyScroll = () => {
  let stickySelectedVariant = document.querySelector(`#sticky__variant`);
  if (stickySelectedVariant) {
    let stickySelectVairantInput = document.querySelector(
      "#sticky__selected_variant_id"
    );
    stickySelectVairantInput.value = stickySelectedVariant.value;
  }

  const productStickyWrapper = document.querySelector(".product__sticky");
  const mainAddToCartButton = document.querySelector(
    ".product_buy_button_form .product-form__submit"
  );
  const mobileStickyQuery = window.matchMedia("(max-width: 767px)");
  let mainButtonVisible = false;

  if (!productStickyWrapper) return;

  const resetSticky = () => {
    productStickyWrapper.classList.remove("sticky");
    document.body.classList.remove("sticky__cart");
  };

  const setStickyState = () => {
    if (!mobileStickyQuery.matches) {
      resetSticky();
      return;
    }

    if (mainButtonVisible) {
      resetSticky();
      return;
    }

    document.documentElement.style.setProperty(
      "--sticky-bar-height",
      `${productStickyWrapper.clientHeight}px`
    );
    productStickyWrapper.classList.add("sticky");
    document.body.classList.add("sticky__cart");
  };

  const updateMainButtonVisibility = () => {
    if (!mainAddToCartButton) {
      mainButtonVisible = false;
      setStickyState();
      return;
    }

    const rect = mainAddToCartButton.getBoundingClientRect();
    mainButtonVisible = rect.bottom > 0 && rect.top < window.innerHeight;
    setStickyState();
  };

  if (mainAddToCartButton && "IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      mainButtonVisible = entries.some((entry) => entry.isIntersecting);
      setStickyState();
    });

    observer.observe(mainAddToCartButton);
  }

  updateMainButtonVisibility();

  window.addEventListener("resize", updateMainButtonVisibility);
  window.addEventListener("scroll", updateMainButtonVisibility, { passive: true });
  mobileStickyQuery.addEventListener("change", setStickyState);
};
stickyScroll();
